import React from "react";
import { useAppDispatch } from "../../app/hooks";
import { Anchor, opened } from "./drawerSlice";
import { FiEdit } from "react-icons/fi";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { IDrawerState } from "./drawerModel";
import IconButton from "../common/IconButton";

interface EditButtonType {
  ID: number;
  drawerName: string;
  anchor?: Anchor;
  label?: string;
  size?: "large" | "small" | "medium";
  tooltipTitle?: string;
  children?: any;
  drawerWidth?: number;
}

const LinkEdit: React.FC<EditButtonType> = (props) => {
  const dispatch = useAppDispatch();

  const handleEdit = (ev: React.MouseEvent) => {
    ev.stopPropagation();
    const drawerOptions: IDrawerState = {
      open: true,
      anchor: props?.anchor || "right",
      name: props?.drawerName,
      drawerWidth: props?.drawerWidth || 400,
      data: props?.ID,
      label: props?.label,
    };
    dispatch(opened(drawerOptions));
  };
  return props?.label || props.children ? (
    <div className="fw-600" onClick={handleEdit}>
      {props.label} {props.children}
    </div>
  ) : (
    <Tooltip anchorElement="target" position="top" parentTitle={true}>
      <IconButton
        type="button"
        fillMode="flat"
        title={props.tooltipTitle || "Edit"}
        themeColor="primary"
        size={props?.size || "small"}
        onClick={handleEdit}
        style={{ width: 35, height: 35, position: "relative" }}
        icon={FiEdit}
        iconClassName="absolute-position"
        iconStyle={{ fontSize: "20px" }}
      />
    </Tooltip>
  );
};

export default LinkEdit;
